<div class="checkpoint">
    <div class="checkpoint__answer" [class]="'checkpoint__answer--' + checkpoint.answer"></div>
    <div class="checkpoint__text"> {{ checkpoint.translations | haTranslate }} </div>
</div>
